$(document).ready(function() {
  var sortObj = {
    selling: { up: "manual", down: "best-selling" },
    price: { up: "price-ascending", down: "price-descending" },
    created: { up: "created-descending", down: "created-ascending" }
  };

  // var handleViewItemClick = function() {
  //   $(".collection-product-grid-item").show();
  //   $(this).hide();
  //   $(".collection-product-grid").addClass("view-all");
  // };
var handleViewItemClick = function() {
  var $btn = $(this);
  var $textSpan = $btn.find('.btn-text');
  var $otherItems = $(".collection-product-grid-item.other");
  var isExpanded = $btn.data("expanded") === true;

  if (!isExpanded) {
    // 展开
    $otherItems.show();
    $btn.data("expanded", true).addClass("expanded");
    $textSpan.text('Rodyti mažiau');
    $(".collection-product-grid").addClass("view-all");
  } else {
    // 收回
    $otherItems.hide();
    $btn.data("expanded", false).removeClass("expanded");
    $textSpan.text('Sužinokite daugiau');
    $(".collection-product-grid").removeClass("view-all");
  }
};

  var handleSortItemClick = function() {
    var $this = $(this);
    var sortValue = $this.data("value");
    var currentOrder = $this.data("order");
    var newOrder= "";
    newOrder = $this.hasClass("active") 
    ? (currentOrder === "up" ? "down" : "up") 
    : currentOrder;

    var sortBy = sortObj[sortValue][newOrder];

    $(".sort-item").removeClass("active");
    $this.addClass("active").data("order", newOrder).attr("data-order", newOrder);

    var params = { sort_by: sortBy };
    var sectionId = $(".collection-product-grid").attr("id");
    $(".collection-product-grid").attr("data-loading", "true");

    const url = `${window.location.pathname}?section_id=${sectionId}&${$.param(params)}`;
    const newUrl = `${window.location.pathname}?${$.param(params)}`;
    history.pushState('', '', newUrl);
  //  console.log(url);
    fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(response => response.text())
    .then(content => {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = content;
      var newCollectionProductGrid = tempElement.querySelector('.collection-product-grid');

      if (newCollectionProductGrid) {
        $('#' + sectionId).html(newCollectionProductGrid.innerHTML);
        updateSortAttributes(sortValue, newOrder);
        rebindEventHandlers();
      }
    })
    .catch(error => console.error('Error:', error))
    .finally(() => $(".collection-product-grid").attr("data-loading", "false"));
  };

  var updateSortAttributes = function(sortValue, newOrder) {
    $(".sort-item").each(function() {
      var $item = $(this);
      if ($item.data("value") === sortValue) {
        $item.data("order", newOrder).attr("data-order", newOrder);
      }
    });
  };

  var rebindEventHandlers = function() {
    $(".sort-item").off('click').on('click', handleSortItemClick);
    $('#view-all-btn').off('click').on('click', handleViewItemClick);
  };

  rebindEventHandlers();
});



// Use Code
$(document).ready(function() {
  $(".product-coupon-code").click(function() {
      var textToCopy = $(this).find("span").text();
      console.log(textToCopy);

      var $tempInput = $('<input>', {
          type: 'text',
          value: textToCopy,
          css: {
              position: 'absolute',
              left: '-9999px'
          }
      }).appendTo('body');
      $tempInput[0].select();
      
      var copied = document.execCommand('copy');
      $tempInput.remove();

      if (copied) {
          var $successMessage = $('<div>', {
              text: 'Copied!',
              css: {
                  position: 'fixed',
                  bottom: '20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  padding: '6px 12px',
                  backgroundColor: '#404A58',
                  color: 'white',
                  textAlign: 'center',
                  borderRadius: '5px',
                  zIndex: '999'
              }
          }).appendTo('body');
          setTimeout(function() {
              $successMessage.fadeOut(500, function() { $(this).remove(); });
          }, 2000);
      }
  });
});

// Product list more btn
$(document).ready(function() {
  $(".product-list__more-btn").click(function() {
    $(this).hide();
    var $closestCollection = $(this).closest('.collection-product-list');
    var handleValue = $closestCollection.data('handle');
    $(`.collection-product-list[data-handle="${handleValue}"] .product-list__item`).show();
  });
});










